import { useGetActivityLogQuery } from 'api/activityLogApi';
import { FormattedDateOnly, FormattedDateTime } from 'components/formatted-date';
import OffCanvasModal from 'components/offCanvas-modal';
import { showToastError } from 'components/toastify/ToastNotifications';
import Layout from 'layout/layout';
import { ActivityLogModel, ActivityLogQuery } from 'model/activity-log-model';
import { useEffect, useState } from 'react'
import { FloatingLabel, Form, Spinner } from 'react-bootstrap';
import { AiOutlineMinus } from 'react-icons/ai';
import { GoChevronRight, GoFilter, GoPlus, GoSearch } from 'react-icons/go';
import { HiOutlineBellAlert } from 'react-icons/hi2';
import emptyFile from '../assets/images/emptydata.gif';
import dayjs from 'dayjs';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css'; // Import Pagination CSS
import { retrieveUserData } from 'redux/authSlice';
import { useGetPermissionsByIdQuery } from 'api/userManagementApi';

type Props = {}

const ActivityLog = (props: Props) => {
    
    const userRoleId = retrieveUserData()?.roleId || '';

    const { data: permissionsData, isFetching: fetchingPermission, refetch: refetchUserPermission } = useGetPermissionsByIdQuery(userRoleId, {skip: userRoleId ? false : true});
    useEffect(() => {
        if (permissionsData?.data) {
            refetchUserPermission();
        }
    }, []);
    const userPermission = permissionsData?.data && permissionsData?.data?.permissions?.includes("View Activity Logs");

    const [loading, setLoading] = useState(false);
    const [showOffCanvas, setShowOffCanvas] = useState(false);
    const [activeAccordion, setActiveAccordion] = useState<number | null>(null);
    const handleHideOffCanvas = () => {
        setShowOffCanvas(false);
    }
    const today = new Date();
    const [searchKeyword, setSearchKeyword] = useState('');
    const [queryParameters, setQueryParameters] = useState<ActivityLogQuery>({
        sDate: dayjs(today).format('YYYY-MM-DD'),
        eDate: dayjs(today).format('YYYY-MM-DD'),
        SearchKeyword: searchKeyword,
        Page: 1,
        PageSize: 10,
    });
    const [activityLogs, setActivityLogs] = useState<ActivityLogModel>();
    const { data: dataLogs, error: errorLogs, isLoading: isLoadingLogs, isFetching: isFetchingLogs, refetch: refetchLogs } = useGetActivityLogQuery(queryParameters);

    useEffect(() => {
        getActivityLogs()
    }, [isFetchingLogs, queryParameters]);

    const getActivityLogs = () => {
        if (isFetchingLogs) {
            setLoading(true);
        }
        else {
            setLoading(false);
            if (errorLogs) {
                showToastError(dataLogs?.ResponseMessage || 'Internal server error occur');
            }
            else {
                setActivityLogs(dataLogs?.data as ActivityLogModel);
                //setQueryParameters({ ...queryParameters, SearchKeyword: '' });
            }
        }
    }
    // Function to handle page change
    const onPageChange = (page: number) => {
        setQueryParameters({ ...queryParameters, Page: page })
        // You can perform actions like fetching data for the new page here
    };

    const [selectedAction, setSelectedAction] = useState('');

    const handleActionChange = (action: string) => {
        setSelectedAction(action);
    };


    return (
        <Layout>
            <div className='mt-4'>
                <h5 className='fw-bold mb-2'>Activity Log</h5>
                <div className='text-secondary font-size-sm'><span>Activity Log</span> <GoChevronRight className='my-2' /></div>
                {loading ? <div className='text-center pt-5 m-auto'><Spinner /><br /> <h4>loading...</h4></div> :
                    <div>
                        <Form>
                            <div className='row'>
                                <div className='col-lg-7 row'>
                                    <div className='col-lg-5'>
                                        <FloatingLabel controlId="floatingSelect" label="Enter a start date" className='float-input'>
                                            <Form.Control type='date' value={dayjs(queryParameters?.sDate).format('YYYY-MM-DD')} onChange={(e) => setQueryParameters({ ...queryParameters, sDate: dayjs(e.target.value).format('YYYY-MM-DD') })} aria-label="Floating label select example" className="border-0 w-100">
                                            </Form.Control>
                                        </FloatingLabel>

                                    </div>
                                    <div className='col-lg-5'>
                                        <FloatingLabel controlId="floatingSelect" label="Enter an end date" className='float-input'>
                                            <Form.Control type='date' value={dayjs(queryParameters?.eDate).format('YYYY-MM-DD')} onChange={(e) => setQueryParameters({ ...queryParameters, eDate: dayjs(e.target.value).format('YYYY-MM-DD') })} aria-label="Floating label select example" className="border-0 w-100">
                                            </Form.Control>
                                        </FloatingLabel>
                                    </div>
                                    {/* <div className='col-lg-2'><button type='button' onClick={()=> getActivityLogs()} className='btn btn-primary py-3 px-4'>View</button></div> */}

                                </div>
                                <div className='col-lg-5 text-end my-auto'>
                                    <Form.Control type='text' onChange={(e) => setSearchKeyword(e.target.value)} placeholder='Search' className='d-inline rounded-5 search-input light-text w-50 me-2 py-2' />
                                    <button type='button' onClick={() => setQueryParameters({ ...queryParameters, SearchKeyword: searchKeyword })} className='btn-primary py-2 px-3 me-3'><GoSearch size={20} /></button>
                                    {queryParameters.SearchKeyword && <button type='button' onClick={() => setQueryParameters({ ...queryParameters, SearchKeyword: '', ActionType: '' })} className='btn btn-secondary'>Clear Filter</button>}
                                    <button type='button' onClick={() => setShowOffCanvas(true)} className='btn-secondary-outline px-3'> <GoFilter size={20} className='me-2' /> Filter</button>
                                    <OffCanvasModal showOffCanvas={showOffCanvas} hideOffCanvas={handleHideOffCanvas}>
                                        <div className='px-4'>
                                            <h3 className='fw-bold mt-n4 mb-4'>Filter</h3>
                                            <div className='mb-5'>
                                                <p className="dark-text">Activity Type</p>
                                                <p><Form.Check label='Creation' id='Creation' name='actionType' checked={selectedAction === 'Creation'}
                                                    onChange={() => handleActionChange('Creation')} className="dark-text" /></p>
                                                <p><Form.Check label='Modification' name='actionType' id='Modification' checked={selectedAction === 'Modification'}
                                                    onChange={() => handleActionChange('Modification')} className="dark-text" /></p>
                                                <p><Form.Check label='Deletion' name='actionType' id='Deletion' checked={selectedAction === 'Deletion'}
                                                    onChange={() => handleActionChange('Deletion')} className="dark-text" /></p>
                                                <p><Form.Check label='Login' name='actionType' id='Login' checked={selectedAction === 'Login'}
                                                    onChange={() => handleActionChange('Login')} className="dark-text" /></p>
                                                <p><Form.Check label='Logout' name='actionType' id='Logout' checked={selectedAction === 'Logout'}
                                                    onChange={() => handleActionChange('Logout')} className="dark-text" /></p>
                                                <p><Form.Check label='View' name='actionType' id='View' checked={selectedAction === 'View'}
                                                    onChange={() => handleActionChange('View')} className="dark-text" /></p>
                                                <p><Form.Check label='Publish' name='actionType' id='Publish' checked={selectedAction === 'Publish'}
                                                    onChange={() => handleActionChange('Publish')} className="dark-text" /></p>
                                                <p><Form.Check label='Assign' name='actionType' id='Assign' checked={selectedAction === 'Assign'}
                                                    onChange={() => handleActionChange('Assign')} className="dark-text" /></p>
                                                <p><Form.Check label='Subscription' name='actionType' id='Subscription' checked={selectedAction === 'Subscription'}
                                                    onChange={() => handleActionChange('Subscription')} className="dark-text" /></p>
                                            </div>
                                            <div className='pt-5'><button type='button' onClick={() => { handleHideOffCanvas(); setQueryParameters({ ...queryParameters, ActionType: selectedAction }) }} className='btn-primary w-100 py-2'>Apply filter</button></div>
                                        </div>
                                    </OffCanvasModal>
                                </div>
                            </div>
                        </Form>
                        {activityLogs && activityLogs?.items?.length > 0 ? <> {activityLogs?.items?.map((item, key) => <div key={key} className='row'>
                            <div className='col-lg-8 d-flex gap-4 mx-auto pt-5'>
                                <div className='w-25 text-end mx-auto'>
                                    <span className='pe-3'>{FormattedDateOnly(item?.date)}</span>
                                    <span onClick={() => setActiveAccordion(activeAccordion === key ? null : key)} style={{ cursor: 'pointer' }}>
                                        {activeAccordion === key ? <GoPlus size={40} className='bg-outline-secondary p-2 rounded-circle' /> : <AiOutlineMinus size={40} className='bg-outline-secondary p-2 rounded-circle' />}
                                    </span>
                                </div>
                                <div className='w-75 mx-auto'>
                                    <div className='bg-outline-secondary py-2 px-3 rounded-3 font-size-normal'>
                                        <p className='pb-1 m-0'>{item?.activities[0]?.actionType}: <span className='text-primary'>{item?.activities[0]?.user}</span> {item?.activities[0]?.actionDescription}</p>
                                        <span className='text-secondary font-size-smm'>{FormattedDateTime(item?.activities[0]?.date)}</span>
                                    </div>
                                </div>
                            </div>
                            {activeAccordion === key && item?.activities.slice(1).map((list, subKey) => (
                                <div key={subKey} className='col-lg-8 d-flex gap-4 mx-auto'>
                                    <div className='w-25 text-end mx-auto'>
                                        <p className='pt-2'><HiOutlineBellAlert size={40} className='bg-outline-secondary p-2 rounded-circle' /></p>
                                    </div>
                                    <div className='w-75 mx-auto'>
                                        <div className='bg-outline-secondary py-2 px-3 rounded-3 font-size-normal'>
                                            <p className='pb-1 m-0'>{list?.actionType}: <span className='text-primary'>{list?.user}</span> {list?.actionDescription}</p>
                                            <span className='text-secondary font-size-smm'>{FormattedDateTime(list?.date)}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>)}
                            <div className='text-end py-3'>
                                <Pagination
                                    current={activityLogs?.pageNumber || 0}
                                    total={activityLogs?.totalSize}
                                    pageSize={activityLogs?.pageSize}
                                    onChange={onPageChange}
                                />
                            </div>
                        </>
                            : <div className='p-5 text-center'><img src={emptyFile} width='200px' /><h5>No available data</h5></div>}
                    </div>
                }
            </div>
        </Layout>
    )
}

export default ActivityLog;
